import * as actions from '../actionTypes/orderChatbotAnalyticsActionTypes';

export const getOrderChatbotAnalytics = (_data: any, _callback?: any) => {
    return {
        type: actions.GET_ORDER_CHATBOT_ANALYTICS,
        payload: _data,
        callback: _callback
    }
}

export const setOrderChatbotAnalytics = (_data: any) => {
    return {
        type: actions.SET_ORDER_CHATBOT_ANALYTICS,
        payload: _data
    }
}

export const setOrderChatbotAnalyticsLoader = (_data: boolean) => {
    return {
        type: actions.SET_ORDER_CHATBOT_ANALYTICS_LOADER,
        payload: _data
    }
}

export const setOrderChatbotAnalyticsError = (_data: any) => {
    return {
        type: actions.SET_ORDER_CHATBOT_ANALYTICS_ERROR,
        payload: _data
    }
}

export const resetOrderChatbotAnalytics = () => {
    return {
        type: actions.RESET_ORDER_CHATBOT_ANALYTICS
    }
}

// Conversations Action Creators
export const getChatbotConversations = (_data: any, _callback?: any) => {
    return {
        type: actions.GET_CHATBOT_CONVERSATIONS,
        payload: _data,
        callback: _callback
    }
}

export const setChatbotConversations = (_data: any) => {
    return {
        type: actions.SET_CHATBOT_CONVERSATIONS,
        payload: _data
    }
}

export const setChatbotConversationsLoader = (_data: boolean) => {
    return {
        type: actions.SET_CHATBOT_CONVERSATIONS_LOADER,
        payload: _data
    }
}

export const setChatbotConversationsError = (_data: any) => {
    return {
        type: actions.SET_CHATBOT_CONVERSATIONS_ERROR,
        payload: _data
    }
}

export const resetChatbotConversations = () => {
    return {
        type: actions.RESET_CHATBOT_CONVERSATIONS
    }
}